module.exports = __webpack_public_path__ + "img/U1F355.32e7f90a.png";